// extracted by mini-css-extract-plugin
module.exports = {"vipCustomer":"Vip_vipCustomer_1k1tU","container":"Vip_container_1WDYv"};